export const style = {
  variant: 'text',
  size: 'medium',
  colorActive: 'secondary.main',
  colorDefault: 'text.primary',
} as const;
